module.exports = __webpack_public_path__ + "img/users.4b38c05e.svg";